import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * Mine Uğur — tek kişilik iletişim sayfası.
 *
 * 15.09.2026'da istendi. Verilen tek bilgi isim, cep telefonu ve e-posta
 * adresi; unvan, özgeçmiş ve fotoğraf verilmedi, o yüzden sayfada da yok.
 * İngilizce sayfadaki `check` notu unvanı ve bir portre fotoğrafını istiyor.
 *
 * 15.09.2026'da ekip iletişim sayfalarının birbiriyle bütünlüklü olması istendi:
 * ortalanmış isim, kart başlığının doğrudan adres ya da numara olduğu bir
 * `features` grid'i ve sonda diğer kartlarla aynı iletişim bandı.
 */
const EMAIL = 'mine@digitopia.ai'
const PHONE = '+90 532 514 73 94'
const PHONE_HREF = 'tel:+905325147394'

export const teamMineUgur: WrittenPage = {
  navLabel: 'Mine Uğur',
  title: 'Mine Uğur',
  description: `Digitopia'dan Mine Uğur'a ulaşın: ${EMAIL}, ${PHONE}.`,
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Digitopia',
      headline: 'Mine Uğur',
      align: 'center',
      ctas: [
        { label: 'E-posta', href: `mailto:${EMAIL}` },
        { label: 'Ara', href: PHONE_HREF },
        // 17.09.2026: telefona doğrudan kaydetmek için vCard. Dosya
        // `public/vcf/` içinde, sayfanın slug'ıyla aynı adda.
        { label: 'Rehbere kaydet', href: '/vcf/mine-ugur.vcf' },
      ],
    },
    {
      kind: 'features',
      heading: 'İletişim',
      columns: 2,
      items: [
        {
          title: EMAIL,
          note: 'E-posta',
          href: `mailto:${EMAIL}`,
        },
        {
          title: PHONE,
          note: 'Türkiye',
          href: PHONE_HREF,
        },
      ],
    },
    {
      kind: 'cta',
      heading: 'Kişi yerine firmayla mı başlamak istersiniz?',
      sub: 'İletişim formu tüm ekibe ulaşır; Hakkımızda ise birlikte çalışacağınız diğer isimleri anlatır.',
      tone: 'band',
      ctas: [
        { label: 'Digitopia ile iletişime geçin', href: LINKS.contact },
        { label: 'Hakkımızda', href: LINKS.about },
      ],
    },
  ],
}
